export class ResourceSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsEc2",
            "baseName": "awsEc2",
            "type": "AwsEc2SnapshotProperties",
            "format": ""
        },
        {
            "name": "awsRds",
            "baseName": "awsRds",
            "type": "AwsRdsSnapshotProperties",
            "format": ""
        },
        {
            "name": "awsEbsVolume",
            "baseName": "awsEbsVolume",
            "type": "AwsEbsVolumeSnapshotProperties",
            "format": ""
        },
        {
            "name": "awsEksNamespace",
            "baseName": "awsEksNamespace",
            "type": "AwsEksNamespaceSnapshotProperties",
            "format": ""
        },
        {
            "name": "awsDynamoDb",
            "baseName": "awsDynamoDb",
            "type": "AwsDynamoDbSnapshotProperties",
            "format": ""
        },
        {
            "name": "azureVm",
            "baseName": "azureVm",
            "type": "AzureVmSnapshotProperties",
            "format": ""
        },
        {
            "name": "azureMssql",
            "baseName": "azureMssql",
            "type": "AzureMssqlSnapshotProperties",
            "format": ""
        },
        {
            "name": "gcpVm",
            "baseName": "gcpVm",
            "type": "GcpVmSnapshotProperties",
            "format": ""
        },
        {
            "name": "gcpCloudSql",
            "baseName": "gcpCloudSql",
            "type": "GcpCloudSqlSnapshotProperties",
            "format": ""
        },
        {
            "name": "gcpDisk",
            "baseName": "gcpDisk",
            "type": "GcpDiskSnapshotProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
